export default {

  updatePatient(state, patient) {
    state.patient = patient
  },

  updateOrderDetails(state, orderDetails) {
    state.orderDetails = orderDetails
  },

  updateSelectedMedicines(state, medicines) {
    state.selectedMedicines = medicines
  },

  updateShippingFee(state, shippingFee) {
    state.shippingFee = shippingFee
  },

  updateShippingDate(state, shippingDate) {
    state.shippingDate = shippingDate
  },

  updateMinDate(state, minDate) {
    state.minDate = minDate
  },

  updateMaxDate(state, maxDate) {
    state.maxDate = maxDate
  },

  updateState(_state, state) {
    _state.state = state
  },

  updateCity(state, city) {
    state.city = city
  },

  updateBranch(state, branch) {
    state.branch = branch
  },

  updateBranchName(state, setBranchName) {
    state.branchName = setBranchName
  },

  updateBranchAddress(state, setBranchAddress) {
    state.branchAddress = setBranchAddress
  },

  updateSchedule(state, schedule) {
    state.schedule = schedule
  },

  updateScheduleName(state, scheduleName) {
    state.scheduleName = scheduleName
  },

  updateProvider(state, provider) {
    state.provider = provider
  },

  updateAddress(state, address) {
    state.address = address
  },

  updatePhone(state, phone) {
    state.phone = phone
  },

  updateCellPhone(state, cellPhone) {
    state.cellPhone = cellPhone
  },

  updateObservations(state, observations) {
    state.observations = observations
  },

  updatenameNomenclature(state, nameNomenclature) {
    state.nameNomenclature = nameNomenclature
  },

  updatenumberOne(state, numberOne) {
    state.numberOne = numberOne
  },

  updatenumberTwo(state, numberTwo) {
    state.numberTwo = numberTwo
  },

  updatenumberThree(state, numberThree) {
    state.numberThree = numberThree
  },
  updatepropertyType(state, propertyType) {
    state.propertyType = propertyType
  },
  updatecomplementOne(state, complementOne) {
    state.complementOne = complementOne
  },
  updateblockOrInside(state, blockOrInside) {
    state.blockOrInside = blockOrInside
  },
  updatecomplementTwo(state, complementTwo) {
    state.complementTwo = complementTwo
  }
}
